export default {"src":"/_next/static/media/triangle-right.16ae511e.svg","height":10,"width":5,"blurWidth":0,"blurHeight":0};